<template>
  <div class="landing-page-cover-editor">
    <v-form class="pb-6">
      <div class="inputs pl-6 pt-6">
        <div class="d-flex align-center">
          <v-text-field
            solo
            rounded
            hide-details
            disabled
            label="Imagem"
          ></v-text-field>
          <v-switch
            v-model="configurations.coverSrc.visible"
            inset
            class="ml-6"
            @change="toggle('coverSrc', $event)">
          </v-switch>
          <sigfoco-upload-file
            v-if="configurations.coverSrc.visible"
            :size="12"
            :maxSize="0.5"
            :formats="'.PNG, .JPG, .JPEG'"
            v-model="theSection.coverSrc"
            onlyIcon
            ref="uploadFileComponentCover"
          ></sigfoco-upload-file>
        </div>
        <span v-if="configurations.coverSrc.visible">A imagem de capa do sistema deve ser anexada no formato horizontal (orientação paisagem), para a correta exibição no layout.</span>

        <div class="d-flex align-center">
          <v-select
            v-model="theSection.dark"
            :items="configurations.dark.options"
            item-text="title"
            item-value="value"
            solo
            rounded
            hide-details
            label="Modo de Exibição"
          ></v-select>
          <v-switch
            v-model="configurations.dark.visible"
            inset
            class="ml-6"
            @change="toggle('dark', $event)">
          </v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            solo
            rounded
            hide-details
            label="Logotipo"
            disabled
            @input="onChange('logoSrc', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.logoSrc.visible"
            inset
            class="ml-6"
            @change="toggle('logoSrc', $event)"
          ></v-switch>
          <sigfoco-upload-file
            v-if="configurations.logoSrc.visible"
            :size="12"
            :maxSize="0.1"
            :formats="'.PNG, .JPG, .JPEG'"
            v-model="theSection.logoSrc"
            onlyIcon
            ref="uploadFileComponentLogo"
          ></sigfoco-upload-file>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.title"
            solo
            rounded
            hide-details
            label="Título"
            maxlength="100"
            :disabled="!configurations.title.visible"
            @input="onChange('title', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.title.visible"
            inset
            class="ml-6"
            @change="toggle('title', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.secondText"
            solo
            rounded
            hide-details
            label="Informação"
            maxlength="200"
            :disabled="!configurations.secondText.visible"
            @input="onChange('secondText', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.secondText.visible"
            inset
            class="ml-6"
            @change="toggle('secondText', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.thirdText"
            solo
            rounded
            hide-details
            label="Descrição"
            maxlength="500"
            :disabled="!configurations.thirdText.visible"
            @input="onChange('thirdText', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.thirdText.visible"
            inset
            class="ml-6"
            @change="toggle('thirdText', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.loginButton.title"
            solo
            rounded
            hide-details
            label="URL do Logotipo"
            :disabled="!configurations.loginButton.title.visible"
            @input="onChange('loginButton.title', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.loginButton.title.visible"
            inset
            class="ml-6"
            @change="toggle('loginButton.title', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.loginButton.path"
            solo
            rounded
            hide-details
            label="URL de Acesso"
            :disabled="!configurations.loginButton.path.visible"
            @input="onChange('loginButton.path', $event)"
          ></v-text-field>
          <v-switch disabled inset class="ml-6" :input-value="true"></v-switch>
        </div>
      </div>

      <div class="d-flex flex-row-reverse pt-6">
        <v-menu
          v-model="menuSave"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="success"
              rounded
              text
              class="text-capitalize mr-4"
              >Salvar</v-btn
            >
          </template>
          <v-card max-width="300" class="not-margin">
            <v-card-title class="text-h5"> Deseja confirmar essa operação? </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                text
                small
                class="py-4"
                @click="menuSave = false"
              >
                Desistir
              </v-btn>
              <v-btn
                color="error darken-1"
                rounded
                text
                small
                class="py-4"
                @click="save"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-menu
          v-model="menuDelete"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="error"
              rounded
              text
              class="text-capitalize mr-4"
              >Remover</v-btn
            >
          </template>
          <v-card max-width="300" class="not-margin">
            <v-card-title class="text-h5"> Tem Certeza? </v-card-title>

            <v-card-text>
              Se você continuar, esta seção será removida da página inicial do
              sistema.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                text
                small
                class="py-4"
                @click="menuDelete = false"
              >
                Desistir
              </v-btn>
              <v-btn
                color="error darken-1"
                rounded
                text
                small
                class="py-4"
                @click="remove"
              >
                Remover
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </v-form>
  </div>
</template>

<script>
import { get as _get, set as _set } from "lodash";

import { Cover } from "components/landing-page/LandingPageCover";

export default {
  name: "LandingPageEditorCoverEditor",
  props: {
    section: {
      type: Cover,
      required: true
    }
  },
  data: () => ({
    menuDelete: false,
    menuSave: false,
    theSection: new Cover(),
    configurations: {
      coverSrc: {
        visible: true,
        value: undefined
      },
      logoSrc: {
        visible: true,
        value: undefined
      },
      dark: {
        value: undefined,
        options: [
          { title: "Escuro", value: true },
          { title: "Claro", value: false }
        ]
      },
      title: {
        visible: true,
        value: undefined
      },
      secondText: {
        visible: true,
        value: undefined
      },
      thirdText: {
        visible: true,
        value: undefined
      },
      loginButton: {
        title: {
          visible: true,
          value: undefined
        },
        path: {
          visible: true,
          value: undefined
        }
      }
    }
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.theSection = this.section;
      this.$refs.uploadFileComponentCover.setAnexo(this.theSection.coverSrc);
      this.$refs.uploadFileComponentLogo.setAnexo(this.theSection.logoSrc);

      this.confitureItem("logoSrc");
      this.confitureItem("title");
      this.confitureItem("secondText");
      this.confitureItem("thirdText");
      this.confitureItem("loginButton.title");
      this.confitureItem("loginButton.path");
    },
    confitureItem(modelPath) {
      const model = _get(this.theSection, modelPath);
      const configuration = _get(this.configurations, modelPath);

      configuration.visible = !!model;
      configuration.value = model;
    },
    remove() {
      this.$emit("on-remove", this.section);
    },
    save() {
      this.$emit("on-save", this.section);
      this.menuSave = false;
    },
    toggle(modelPath, visible) {
      const configuration = _get(this.configurations, modelPath);
      configuration.visible = visible;

      if (visible) {
        _set(this.theSection, modelPath, configuration.value);
      } else {
        _set(this.theSection, modelPath, undefined);
      }
    },
    onChange(convigurationPath, value) {
      _set(this.configurations, convigurationPath + ".value", value);
    }
  }
};
</script>
